import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Typography } from "@mui/material";
import AppIcon from "ui/components/icons/AppIcon";
import { iconChevronRight } from "ui/components/icons";
import useHighlight, { globalSearchMarkStyle } from "data/hooks/useHighlight";
import { useGlobalSearchContext } from "../SearchProvider";
import { GlobalSearchEntity } from "data/@types/GlobalSearchData";
import { FirmContent } from "data/@types/Firm";
import { EntityType } from "data/@types/Entity";

type Props = {
  entityType: EntityType;
  firm: FirmContent;
  entity?: GlobalSearchEntity | null;
};

const getEntityDetailsRoute = (
  entityType: EntityType,
  firm: FirmContent,
  entity?: GlobalSearchEntity | null,
) => {
  if (["Product", "Strategy"].includes(entityType)) {
    return `/${entityType.toLowerCase()}-details/${entity?.id}`;
  }

  if (entityType === "Firm") {
    return `/${entityType.toLowerCase()}-details/${firm?.id}`;
  }

  console.error(
    'Entity type should be one of the following: ["Firm", "Product", "Strategy"], but was',
    entityType,
  );

  return "/home";
};

const GlobalSearchItemHeader = ({ entityType, firm, entity }: Props) => {
  const { search, handleClose } = useGlobalSearchContext();
  const { highlight } = useHighlight(search, globalSearchMarkStyle);
  const entityDetailsRoute = getEntityDetailsRoute(entityType, firm, entity);

  return (
    <RouterLink
      to={entityDetailsRoute}
      onClick={handleClose}
      style={{ textDecoration: "none" }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: "normal",
          fontSize: "12px",
          color: "text.primary",
          "&:hover": {
            textDecoration: "underline",
            ".highlight-text": {
              textDecoration: "underline",
            },
            svg: {
              borderBottomColor: "text.primary",
            },
          },
        }}
      >
        {/* TODO: remove the safety navigator as firm should never be null. Currently, a few null firms were found */}
        <span dangerouslySetInnerHTML={{ __html: highlight(firm?.longName) }} />
        {entity?.longName && (
          <>
            <AppIcon
              icon={iconChevronRight}
              sx={{
                fontSize: "1em",
                color: "text.secondary",
                borderBottom: "1px solid transparent",
                transform: "translateY(2px)",
                paddingTop: "2px",
              }}
            />
            <span
              dangerouslySetInnerHTML={{ __html: highlight(entity.longName) }}
            />
          </>
        )}
      </Typography>
    </RouterLink>
  );
};

export default GlobalSearchItemHeader;
